export const SHIFTS_B2B_TABLE_COLUMNS_WIDTH =
  'auto auto auto auto auto auto auto auto auto auto auto auto';

export const SHIFTS_WITH_ACTION_B2B_TABLE_COLUMNS_WIDTH =
  'auto auto auto auto auto auto auto auto auto auto';

export const SHIFTS_WITH_OUT_ACTION_B2B_TABLE_COLUMNS_WIDTH =
  'auto auto auto auto auto auto auto auto auto';

export const SHIFTS_AGENCY_TABLE_COLUMNS_WIDTH =
  'auto auto auto auto auto auto auto auto auto auto auto auto auto auto';
